import { getDeptEmployees, getPageSubDeptList } from "@/apis/dept.api";
import { QueryDeptEmployeesSchema } from "@/types/apis";
import { useQuery } from "@tanstack/react-query";

// 获取部门下员工数据
export function useDeptEmployees(data: QueryDeptEmployeesSchema) {
  const { data: res, isLoading } = useQuery({
    queryKey: ["deptEmployees", data],
    queryFn: () =>
      getDeptEmployees({
        ...data,
        pageNum: data.pageNum || 1,
        pageSize: data.pageSize || 10,
      }),
    // 当有部门号或搜索值时才发起查询
    enabled: !!data.deptNo || !!data.searchValue,
  });

  const list = res?.data.data.list ?? [];

  return {
    employeeList: list,
    isLoading,
  };
}

/**
 * 分页查询系统用户（包含子部门用户）列表
 * 支持按姓名、昵称进行模糊查询
 */
export function usePageSubDeptEmployeesQuery(data: QueryDeptEmployeesSchema) {
  const { data: res, isLoading } = useQuery({
    queryKey: ["pageSubDeptEmployees", data],
    queryFn: () =>
      getPageSubDeptList({
        ...data,
        deptNo: data.deptNo,
        searchValue: data.searchValue,
      }),
    // 当有部门号时才发起查询，或者有搜索值时也发起查询
    enabled: !!data.deptNo || !!data.searchValue,
  });

  const list = res?.data.data.list ?? [];

  return {
    employeeList: list,
    isLoading,
  };
}
